<template>
    <div id="box">
        <el-row type="flex" justify="center" style="text-align: center" align="middle">
            <el-col :span="1" :xs="{span:11,offset:1}"><img src="../assets/logo.png" alt="logo"/></el-col>

            <el-col :lg="{span:1,offset:16}" :md="{span:1,offset:14}" :sm="{span:1,offset:14}" :xs="{span:4,}">
                <a class="href-url" href="#home">Home</a>
            </el-col>

            <el-col :lg="{span:1,offset:1}" :md="{span:1,offset:1}" :sm="{span:1,offset:1}" :xs="{span:4,}">
                <a class="href-url" href="#contact">Contact</a>
            </el-col>

            <el-col :lg="{span:1,offset:1}" :md="{span:1,offset:1}" :sm="{span:1,offset:1}" :xs="{span:4,}">
                <a href="#login" class="href-url">Login</a>
            </el-col>
        </el-row>

        <div class="header">
            <el-row type="flex" style="padding-top: 11%">
                <el-col :span="8" :offset="2" style="margin-right: 5px">
                    <div style="color:#0a609b;font-size: 34px;font-weight: bold">Smart Living with Eazable</div>

                    <div style="font-size: 18px;margin-top: 3%;text-align: justify;text-justify: inter-word;line-height: 1.4;">
                        Introducing the brand new lifestyle platform - Eazable!
                        Experience the smarter way to get through your hectic
                        schedule with a multitude of features that eases your
                        daily routine. Engage, connect and discover more
                        within your fingertips on Eazable!
                    </div>
                </el-col>

                <el-col :span="3" style="text-align: center">
                    <div style="color: #4d4d4d;font-size: 18px;font-weight: bold">Download</div>
                    <div style="font-size: 15px;">the App!</div>
                    <img src="../assets/newQR.jpg" style="width: 120px;margin-top: 12px;" alt="qr code"/>
                </el-col>

                <el-col :span="2">
                    <img style="display: block;margin-top: 50px;" src="../assets/app_store.png" alt="app store"/>
                    <img style="margin-top: 30px;" src="../assets/google_play.png" alt="google play store"/>
                </el-col>
            </el-row>

            <div style="text-align: center;margin-top: 24%;width: 100%;font-size: 31px;color: #0a609b;font-weight: bold">The
                All-in-one Lifestyle App
            </div>

            <el-row style="text-align: center;margin-top: 2%;padding-bottom: 5%" type="flex" justify="center">
                <el-col :md="{span:3}" :sm="{span:4}" :xs="{span:5}" v-for="(item,index) in fea" :key="index">
                    <img style="height: 75%" :src="item.img" alt="items"/>
                    <div style="margin-top: 25px;font-size: 15px;color:#4d4d4d;font-weight: bold">{{item.title}}</div>
                </el-col>
            </el-row>
        </div>

        <a name="home"></a>

        <div>
            <el-row type="flex" justify="center" style="margin-top: 7%">
                <el-col :md="{span:10,offset:2}" :sm="{span:10,offset:2}" :xs="{span:10,offset:2}"
                        style="text-align: center">
                    <div style="font-size: 31px;color:#0a609b;font-weight: bold">MY PROPERTY</div>
                    <div style="margin-top: 3%;text-align: center;line-height: 1.3;font-size: 18px">
                        Connect to your property anytime, anywhere! Eazable acts as a platform for
                        users to interact with the management seamlessly. Integrated with multiple
                        exclusive features, users can simply meet their property needs within a matter
                        of seconds. Experience smart living at your property now!
                    </div>
                </el-col>

                <el-col :md="{span:10,offset:1}" :sm="{span:10,offset:1}" :xs="{span:10,offset:1}">
                    <el-row id="u">
                        <el-col :span="8" style="margin-right: 20px">
                            <div style="font-size: 18px;color:#4d4d4d;margin-bottom: 10px;">Using the previous version of Eazable?</div>
                            <div style="font-size: 14px;color:#4d4d4d">Download the new eazable app and transfer your
                                account.
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <img src="../assets/newQR.jpg" alt="qr code"/>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <el-row type="flex" justify="center" style="text-align: center;margin-top: 50px;">
                <el-col v-for="(item,index) in features" :md="{span:3,offset:1}" :sm="{span:4}" :xs="{span:5,}"
                        :key="index">
                    <img :src="item.img" alt="items"/>
                    <div style="font-size: 21px;color: #1d5577;margin: 25px 5px;font-weight: bold;">{{item.header}}</div>
                    <div style="font-size: 17px;color: #4d4d4d;margin: 25px 5px">{{item.content}}</div>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="text-align: center">
                <el-col :span="4" v-for="(item,index) in properties" :key="index">
                    <img :src="item.img" alt="items" style="margin-top: 10px"/>
                    <div style="color: #4d4d4d">
                        {{item.content}}
                    </div>
                </el-col>
            </el-row>
        </div>

        <div class="service">
            <img src="../assets/20180913104404_bce96190bed64ccf97d9774780c2e3b2.png" alt="background"/>
        </div>

        <div class="access">
            <div class="access-header">SMART VISITOR ACCESS</div>
            <el-row type="flex" justify="center">
                <el-col :span="4">
                    <img src="../assets/unlock-hand.png" alt="unlock"/>
                    <div class="access-s-header">One Tap Unlock</div>
                    <div class="access-s-content">
                        <p>Allow access easily through</p>
                        <p>a single tap on Eazable.</p>
                    </div>
                </el-col>
                <el-col :span="4">
                    <img src="../assets/17418 [Converted]-27.png" alt="qr"/>

                    <div class="access-s-header">QR Code Generation</div>
                    <div class="access-s-content">
                        <p>Generate QR codes for</p>
                        <p>visitors to scan and gain</p>
                        <p>access at the gates.</p>
                    </div>
                </el-col>
                <el-col :span="4">
                    <img src="../assets/17418 [Converted]-28.png" alt="video"/>

                    <div class="access-s-header">Video Call</div>
                    <div class="access-s-content">
                        <p>Communicate with visitors</p>
                        <p>through Eazable video call before</p>
                        <p>allowing access.</p>
                    </div>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center">

                <el-col :span="4">
                    <img src="../assets/17418 [Converted]-29.png" alt="human"/>
                    <div class="access-s-header">Monitoring Centre Line</div>
                    <div class="access-s-content">
                        <p>Contact our security officers at the</p>
                        <p>Monitoring Centre to verify</p>
                        <p>identification and gain access.</p>
                    </div>
                </el-col>
                <el-col :span="4">
                    <img src="../assets/17418 [Converted]-30.png" alt="car"/>
                    <div class="access-s-header">Vehicle Plate Registration</div>
                    <div class="access-s-content">
                        <p>With plate recognition cameras, barriers</p>
                        <p>automatically open for registered</p>
                        <p>vehicles.</p>
                    </div>
                </el-col>
            </el-row>
            <div class="access-agsi" id="agsi" style="margin-top: 2%">
                <div>Supported by</div>
                <img src="../assets/agsi.png" style="margin-top: -1%" alt="agsi"/>
                <div style="padding-bottom:8%;margin-top: -1%;font-size: 20px;text-decoration:unset"><a
                        href="http://www.agsi.sg">www.agsi.sg</a></div>
            </div>

        </div>

        <a name="login"></a>

        <div class="download">
            <el-row type="flex" justify="center">
                <el-col :span="10" v-for="(item,index) in other" :key="index">
                    <div class="download-title">
                        <p>Eazable</p>
                        <p>{{item.title}}</p>
                    </div>
                    <el-row type="flex" justify="center" class="download-img-box">
                        <div style="margin-right: 20px"><img :src="item.logo" alt="logo"/></div>
                        <div>
                            <div>
                                <p>Up on the App</p>
                            </div>
                            <img :src="item.qr" style="width: 156px;margin-top: 22px;" alt="qr"/></div>
                    </el-row>
                    <div class="download-content" v-html="item.content">
                    </div>
                    <div class="login-box" @click="showLogin(item.link)">{{item.btn}}</div>
                </el-col>
            </el-row>
        </div>

        <div class="future">
            <div class="future-title">COMING SOON</div>
            <el-row type="flex" justify="center">
                <el-col :span="5">
                    <img class="t-icon" src="../assets/my-community.png" alt="community"/>
                    <div class="f-item-title">My Community</div>
                    <div class="f-content">
                        Get updated with the latest announcements and happenings
                        in your community through the news feed.
                    </div>
                </el-col>
                <el-col :span="5">
                    <img class="t-icon" src="../assets/marketplace.png" alt="market"/>
                    <div class="f-item-title">Marketplace</div>
                    <div class="f-content">
                        Search for nearby shops and businesses such as restaurants, supermarkets and
                        many more! Instantly order your items through a click of a button.
                    </div>
                </el-col>
                <el-col :span="5">
                    <img class="t-icon" src="../assets/property-hub.png" alt="hub"/>
                    <div class="f-item-title">Property Hub</div>
                    <div class="f-content">
                        Source for featured properties in the market. Find your ideal home
                        and make the most out of your current property.
                    </div>
                </el-col>
                <el-col :span="5">
                    <img class="t-icon" src="../assets/auctions.png" alt="auctions"/>
                    <div class="f-item-title">Auctions</div>
                    <div class="f-content">
                        Buy and sell items efficiently at the best prices through
                        the Eazable bidding system.
                    </div>
                </el-col>
            </el-row>
        </div>

        <div class="feedback">
            <el-row type="flex" justify="center">
                <el-col :span="20">
                    <el-row>
                        <el-col>
                            <div style="color: #ffffff;font-size: 31px;margin-top: 40px">Want Eazable in your property?
                            </div>
                            <div style="color:#ffffff;font-size: 27px ">Get in touch with us now!</div>
                        </el-col>

                        <a name="contact"></a>

                        <el-col style="margin-top: 40px">
                            <el-row type="flex" justify="center" style="color: #fff;line-height: 17px;font-size: 17px">
                                <el-col :span="2">
                                    <div style="border: #fff solid 1px;border-radius: 8px;height: 20px;padding: 10px">
                                        Setup Guide
                                    </div>
                                </el-col>
                                <el-col :span="2" :offset="1">
                                    <div>
                                        <div style="border: #fff solid 1px;border-radius: 8px;height: 20px;padding: 10px">
                                            FAQ
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>

                        <el-col style="margin-top: 40px">
                            <el-row type="flex" justify="center">
                                <el-col :span="4">
                                    <el-input placeholder="Name*"></el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-input placeholder="Email*"></el-input>
                                </el-col>
                                <el-col :span="4">
                                    <el-input placeholder="Phone"></el-input>
                                </el-col>
                            </el-row>

                            <el-row type="flex" justify="center" style="margin-top: 10px">
                                <el-col :span="12">
                                    <el-input type="textarea" :rows="7" placeholder="Message"></el-input>
                                </el-col>
                            </el-row>

                            <el-button style="background: #EBF43D;color: #5E387F;font-weight: bold;width: 50%;
                                        margin-top: 15px;padding: 12px 20px" type="text">CONTACT US
                            </el-button>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>

        <footer-bar></footer-bar>

        <div>
            <Login :show.sync="showLoginDialog"></Login>
            <vendor-login :show.sync="showVendorLoginDialog"></vendor-login>
        </div>
    </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
    import FooterBar from './Footer'
    import Login from './Login'
    import VendorLogin from "@/view/VendorLogin";

    export default {
        name: 'Home',
        components: {VendorLogin, Login, FooterBar},
        data() {
            return {
                showLoginDialog: false,
                showVendorLoginDialog: false,
                loginForm: {},
                features: [{
                    img: require('../assets/15.png'),
                    header: 'Facility Booking',
                    content: 'Book facilities with ease and comfort in simple steps.'
                },
                    {
                        img: require('../assets/16.png'),
                        header: 'Digital Forms',
                        content: 'Download and fill up forms seamlessly to send to the management.'
                    },
                    {
                        img: require('../assets/17.png'),
                        header: 'Digital Feedbacks',
                        content: 'Send detailed feedbacks to the management instantly.'
                    },
                    {
                        img: require('../assets/18.png'),
                        header: 'E-Bulletin',
                        content: 'Get updated with the latest news and happenings.'
                    },
                    {
                        img: require('../assets/19.png'),
                        header: 'E-Payment',
                        content: 'Make transactions easily using your E-Wallet!'
                    },
                    {
                        img: require('../assets/20.png'),
                        header: 'E-Voting',
                        content: 'Part of the deciding committee? Make your votes through Eazable.'
                    }],
                properties: [
                    {img: require('../assets/21.png'), content: 'Private Residential Properties (MCSTs)'},
                    {img: require('../assets/22.png'), content: 'Industrial Properties'},
                    {img: require('../assets/23.png'), content: 'Commercial Properties'}
                ],
                fea: [
                    {img: require('../assets/06.png'), title: 'My Property'},
                    {img: require('../assets/07.png'), title: 'Home Services'},
                    {img: require('../assets/08.png'), title: 'Smart Visitor Access'},
                    {img: require('../assets/09.png'), title: 'My Community'},
                    {img: require('../assets/10.png'), title: 'Marketplace'},
                    {img: require('../assets/11.png'), title: 'Property Hub'},
                    {img: require('../assets/12.png'), title: 'Auctions'},
                    {img: require('../assets/14.png'), title: 'Smart Home Control'}
                ],
                other: [
                    {
                        title: 'Facility Management',
                        logo: require('../assets/logo-ma.png'),
                        qr: require('../assets/qr.png'),
                        content: '<div>Ready to take control of your property? ' +
                            'Use Eazable to communicate and engage with users in a property. ' +
                            'Experience a paperless system where announcements ' +
                            'are broadcasted instantly, and procedures such as ' +
                            'bookings and payments are digitalised.</div>',
                        btn: 'MA Login',
                        link: '/ma',
                    },
                    {
                        title: 'Merchant Centre',
                        logo: require('../assets/logo-vendor.png'),
                        qr: require('../assets/qr.png'),
                        content: '<div>At Eazable, we broaden your opportunities to ' +
                            'drive sales with the right end-users. With an ' +
                            'impressive backend generating system, ' +
                            'Eazable is able to project your services to ' +
                            'potential customers around the clock.</div>',
                        btn: 'Vendor Login',
                        link: '/vendor',
                    }
                ],
                otherText: '<p>Download & Sign</p><p>Up on the App</p>'

            }
        }, methods: {
            showLogin(url) {
                if (url === '/vendor') {
                    this.showVendorLoginDialog = true;
                } else {
                    this.showLoginDialog = true
                }
            }
        }
    }
</script>

<style scoped>
    .href-url {
        font-weight: bold;
        cursor: pointer;
        text-decoration-line: none;
        text-decoration-color: black;
        text-decoration-style: unset;
    }

    .header {
        background: url("../assets/02.png") no-repeat;
        background-size: 100% 100%;

    }

    .service {
        width: 100%;
        background: #5F518E;
        text-align: center;
        margin-top: 4%;
    }

    .access {
        text-align: center;
    }

    .access-s-header {
        color: #1d5577;
        font-size: 21px;
        margin: -21px 0 10px 0;
        font-weight: bold;
    }

    .access-s-content {
        color: #4d4d4d;
        font-size: 17px;
        margin-top: 4px;
    }

    .access-header {
        font-weight: bold;
        font-size: 31px;
        color: #0a609b;
    }

    .download {
        text-align: center;
        padding-top: 4%;
        padding-bottom: 4%;
    }

    @media screen and (min-width:960px) and (max-width:1400px){
        .download-title {
            font-size: 22px !important;
            display: inline-block;
            font-weight: bold;
        }

        .download-content {
            color: #4d4d4d;
            font-size: 15px !important;
            text-align: justify !important;
            line-height: 1.3 !important;
            margin-left: 70px !important;
            width: 450px !important;
        }
    }

    /*#agsi:before {*/
    /*content: 'Supported by';*/
    /*}*/

    /*#agsi:after {*/
    /*content: 'www.agsi.sg';*/
    /*}*/

    .access {
        background: url("../assets/car.png") no-repeat bottom;
        background-size: 100% auto;
        margin-top: 4%;
    }

    .download-title {
        font-size: 27px;
        padding-bottom: 20px;
        border-bottom: 1px solid black;
        color: #4d4d4d;
        width: 60%;
        display: inline-block;
    }

    .download-content {
        font-size: 18px;
        color: #4d4d4d;
        margin: 20px 20px 0 120px;
        text-align: justify;
        text-justify: inter-word;
        line-height: 1.3;
        width: 600px;
    }

    .download-img-box {
        margin: 20px 0 -20px 0;
        min-width: 100px;
    }

    .login-box {
        margin-top: 30px;
        border: 1px solid black;
        -moz-border-radius: 100px;
        -webkit-border-radius: 100px;
        border-radius: 100px;
        width: 200px;
        height: 50px;
        line-height: 50px;
        display: inline-block;
        font-size: 23px;
        cursor: pointer;
        color: #4d4d4d;
    }

    .future {
        width: 100%;
        background: #F0F1F2;
        text-align: center;
        padding-bottom: 90px;
    }

    .future-title {
        padding-top: 4%;
        font-size: 29px;
        color: #0a609b;
        font-weight: bold;
    }

    .f-item-title {
        margin-top: 2%;
        font-size: 20px;
        color: #1d5577;
        font-weight: bold;
    }

    .f-content {
        margin: 10px 20px 0 0;
        font-size: 17px;
    }

    .feedback {
        background: #5E387F url("../assets/12334.png") no-repeat bottom;
        background-size: 100% auto;
        text-align: center;
        padding-bottom: 23%;
    }

    #box {
        min-width: 1000px;
    }

</style>